import React, { useState, useContext, useEffect } from "react";
import { SelectValidator } from "react-material-ui-form-validator";
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import { EWContext } from "../../../../context/EWContext";
import { LANGUAGE_TEXT } from "../../../../constants";
import styles from "../../AccountVerificationForm/AccountVerificationForm.module.css"

export default function EligibilitySelect(props) {
    const { question, value, handleSelectChange, customOptions, disabled } = props;
    const accountState = useContext(EWContext)[0];
    const {payeeCheckOption, payeeBillOption, payeeCheckOptionMsg, payeeBillOptionMsg, payeeEWPaymentMethod} = accountState?.conditionSpecificBehaviors || {};
    const [selectValues, setSelectValues] = useState(value);
    const [paymentPayeeMessage, setPaymentPayeeMessage]= useState("");
    let { placeholder } = props;
    if (!placeholder) {
        placeholder = "-- Please Select --";
    }

    const getOptionElements = options => options.map((option, i) => {
      return <option key={i} value={option.value}>
                {option.label}
            </option>
    });

    const defaultMultipleValue = () => {
      return <MenuItem key={`placeHolder-item`} value="" disabled>
              <ListItemText primary={placeholder} />
            </MenuItem>;
    }

    const getOptionMultipleElements = options => options.map((option, i) => {
      return <MenuItem key={`${option.value}-item`} value={option.value}>
              <Checkbox checked={selectValues.indexOf(option.value) > -1} />
              <ListItemText primary={option.value} />
            </MenuItem>
    });

    const getOptions = (multiple) => {
      if(customOptions) {
        return multiple ? getOptionMultipleElements(customOptions) : getOptionElements(customOptions);
      }
      // Getting options from a custom array or taking values ​​from the field itself
      let options = question.field?.options
          ? accountState[question.field.options]
          : question.field?.values;

      if (options) {
          return multiple ? getOptionMultipleElements(options) : getOptionElements(options);
      } else {
          return multiple ? defaultMultipleValue() : <option value=""> {placeholder} </option>;
      }
    };

    const handleChange = (e, id, multiple) => {
      e.persist();
      if(multiple) {
        let valueField = e.target.value  ;
        setSelectValues(valueField);
        handleSelectChange({
          value: valueField,
          textValue: valueField.join(', ')
        }, id);
      } else {
        let textValue = e.target.options[e.target.selectedIndex].text;
        textValue = textValue === "-- Please Select --" ? "" : textValue;
        if(question.id == payeeEWPaymentMethod && textValue == payeeBillOption){
          setPaymentPayeeMessage(payeeBillOptionMsg)
        }else  if(question.id == payeeEWPaymentMethod && textValue == payeeCheckOption){
          setPaymentPayeeMessage(payeeCheckOptionMsg)
        }
        handleSelectChange({
          value: e.target.value,
          textValue
        }, id);
      }
    };

    useEffect(() => {
  // If this select is payeeEWPaymentMethod, and its value was cleared or changed, reset message
  if (question.id === payeeEWPaymentMethod && (!value || value === "")) {
    setPaymentPayeeMessage("");
  }
}, [value, question.id]);
    const simpleSelect = () => {
      return <SelectValidator
                label={
                    question.required ? (
                        <div>
                            {question.label}{paymentPayeeMessage? paymentPayeeMessage:""}
                            <span
                                style={{
                                    color: "red",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                }}
                            >
                                *
                            </span>
                            {" "}
                            {question.helpText &&
                              <div className={ styles.tooltip}> ?
                                <span className={ styles.tooltipText} >{question.helpText}</span>
                              </div>
                            }
                        </div>
                    ) : (
                      <div>
                          {question.label}
                          <span style={{ fontSize: "16px"}} > {" "} </span>
                          {question.helpText &&
                            <div className={ styles.tooltip}> ?
                              <span className={ styles.tooltipText} >{question.helpText}</span>
                            </div>
                          }
                      </div>
                    )
                }
                onChange={(e) => handleChange(e, question.id)}
                name={question.name}
                id={question.id}
                disabled={disabled || question.disabled}
                SelectProps={{
                    native: true,
                    disableUnderline: true,
                    IconComponent: () => (
                        <ExpandMoreOutlinedIcon
                            style={{
                                fill: "#D2D2D4",
                                position: "absolute",
                                top: "15px",
                                right: "15px",
                                zIndex: 0
                            }}
                        />
                    ),
                }}
                value={value || ""}
                validators={question.field.validators}
                fullWidth
                errorMessages={question.field.errorMessages}
                InputLabelProps={{
                    shrink: true,
                }}
            >
                <option value=""> {placeholder} </option>
                {getOptions()}
            </SelectValidator>;
    }

    const multipleSelect = () => {
      const ITEM_HEIGHT = 48;
      const ITEM_PADDING_TOP = 8;
      const MenuProps = {
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: "auto"
          }
        }
      };

      return <FormControl fullWidth>
                <InputLabel shrink id={`${question.id}-label`}>
                  {
                    question.required ? (
                        <div>
                            {question.label}
                            <span
                                style={{
                                    color: "red",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                }}
                            >
                                *
                            </span>
                        </div>
                    ) : (
                        question.label
                    )
                  }
                </InputLabel>
                <Select
                  labelId={`${question.id}-label`}
                  name={question.name}
                  id={question.id}
                  disabled={disabled}
                  multiple
                  value={selectValues}
                  onChange={(e) => handleChange(e, question.id, true)}
                  input={<Input />}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return defaultMultipleValue();
                    }
                    return selected.join(', ');
                  }}
                  MenuProps={MenuProps}
                  fullWidth
                  disableUnderline
                  displayEmpty
                  IconComponent= {() => (
                    <ExpandMoreOutlinedIcon
                        style={{
                            fill: "#D2D2D4",
                            position: "absolute",
                            top: "15px",
                            right: "15px",
                            zIndex: 0
                        }}
                    />
                  )}
                >
                  {defaultMultipleValue()}
                  {getOptions(true)}
                </Select>
              </FormControl>;
    }

    return question.field.multiple ? multipleSelect() : simpleSelect();
}
